import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap, take} from 'rxjs/operators';

import {debug} from '../../../rxjs-operators';
import {LoadTimezonesFailAction, LoadTimezonesSuccessAction, timezonesActionTypes} from '../actions/timezones';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import {SendBackResult} from '../models/send-back-result';
import {Timezone} from '../models/timezone';
import {TimezonesService} from '../services/timezones.service';

import {BaseEffect} from './base.effect';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class TimezonesEffect extends BaseEffect {

  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(timezonesActionTypes.LOAD),
    debug('Load timezones action received;')
  ).pipe(switchMap(() => this.timezonesService.getList().pipe(
      map((payload: SendBackResult<ArrayResponse<Timezone>>) => new LoadTimezonesSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)),
    )),
    take(1))
  });


  loadFail$ = createEffect(() => { return  this.actions$.pipe(
      ofType(timezonesActionTypes.LOAD_FAIL),
      debug('Load timezones fail action received.'),
      map((action: LoadTimezonesFailAction) =>
        error(this.translation.translate('TIMEZONES_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions, private translation: L10nTranslationService, private timezonesService: TimezonesService, router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadTimezonesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadTimezonesFailAction(response['error'].message);
  }
}
